import { render } from "./SliderList.vue?vue&type=template&id=83be43ca&scoped=true"
import script from "./SliderList.vue?vue&type=script&lang=js"
export * from "./SliderList.vue?vue&type=script&lang=js"

import "./SliderList.vue?vue&type=style&index=0&id=83be43ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83be43ca"]])

export default __exports__